// extracted by mini-css-extract-plugin
export default {"genTitre":"generation_genTitre__D6op4"};